import { STATUS, LOCALSTATUS } from '../../config';
// import { t } from '../../components/common/Translate';

export default async function checkStorageBeforeLogout(forms) {
  const formsNotSyncWithStatusInProgess = [];
  const formsNotSyncWithStatusCompleted = [];
  const formSynchroWithIC = [];
  let message;
  const variables = {};

  Object.entries(forms).forEach(([value]) => {
    if (LOCALSTATUS.synchronized !== 10) {
      if (value.status === STATUS.in_progress) {
        formsNotSyncWithStatusInProgess.push(value);
      } else if (value.status === STATUS.completed) {
        formsNotSyncWithStatusCompleted.push(value);
      }
    } else if (value.localStatus === LOCALSTATUS.synchronized) {
      if (value.status === STATUS.in_progress || value.status === STATUS.completed) {
        formSynchroWithIC.push(value);
      }
    }
  });

  const formsNotSynchroWithStatusIC = formsNotSyncWithStatusInProgess.length + formsNotSyncWithStatusCompleted.length;

  if (formsNotSynchroWithStatusIC > 0) {
    variables.notSaved = formsNotSyncWithStatusInProgess.length;
    variables.notSubmited = formsNotSyncWithStatusCompleted.length;
    message = 'logout_unsaved_forms_message';
  } else if (formSynchroWithIC.length > 0) {
    message = 'logout_forbidden_synchro';
  } else {
    message = 'confirm_logout';
  }
  return [message, variables];
}
